/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum AppraisalType {
    Quote = 0,
    Estimate = 1,
    MasterPriceList = 2,
}
